import { render, staticRenderFns } from "./taxi-course-rating.vue?vue&type=template&id=8d80e4f2&scoped=true"
import script from "./taxi-course-rating.vue?vue&type=script&lang=js"
export * from "./taxi-course-rating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d80e4f2",
  null
  
)

export default component.exports